import { IReferenceResponse } from '@shared/interfaces';

export const isIReferenceResponse = (
  child: any
): child is IReferenceResponse => {
  return (
    child &&
    child &&
    typeof child === 'object' &&
    'reference' in child &&
    Array.isArray(child.reference)
  );
};
